import { ApolloError } from "@apollo/client";
import { createContext } from "react";

import { GqlMeGetProjectInfo } from "../api/useMeGetProjectInfoQuery";

const ProjectContext = createContext<{
    loading: boolean;
    error?: ApolloError;
    data?: GqlMeGetProjectInfo;
}>({
    loading: false,
    error: undefined,
    data: undefined,
});

export default ProjectContext;
